import { getAll } from '@/api/tiers';
import { getCountDeclarableAsync } from '@/api/gabed/materiel';
import genererCritereRechercheCollectivite
  from '@/services/gabed/collectivite/genererCritereRecherche';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_COLLECTIVITE,
} from '@/configuration/tiers/tiersConf';
import transformer from '@/services/gabed/collectivite/collectiviteServerTableDataTransformer';
import { getAll as getAllCommandeTlpe } from '@/api/gabed/commandeTlpe';
import {
  DECLARATION,
  MATERIEL_EN_PLACE,
  MONTAGES_ANNEE_PREC,
  DEMONTAGES_ANNEE_PREC,
} from '@/configuration/gabed/tlpe/tlpeConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import * as allTypes from '../../mutation-type';
import {
  SET_TOTAL,
  SET_ITEMS,
  SET_CRITERE_RECHERCHE,
  SET_COLLECTIVITE_LAST_PAYLOAD,
} from './collectivite-mutation-type';

function initialState() {
  return {
    items: [],
    total: 0,
    criteresRecherche: genererCritereRechercheCollectivite(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL](state, total) {
    state.total = total;
  },
  [SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [SET_COLLECTIVITE_LAST_PAYLOAD](state, lastPayload) {
    state.lastPayload = lastPayload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadCollectivite({ commit }, data) {
    data.query.type = TIERS_TYPE_FOURNISSEUR;
    data.query.sousType = [TIERS_SOUS_TYPE_COLLECTIVITE];
    transformer(data);
    const result = await getAll(data);
    result.data.result.items.forEach((collectivite) => {
      collectivite.selected = false;
    });
    commit(SET_COLLECTIVITE_LAST_PAYLOAD, data);
    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    return {};
  },
  async loadDeclaration({ commit }, data) {
    const anneeDeclaration = data.year;
    delete data.year;
    data.query.type = TIERS_TYPE_FOURNISSEUR;
    data.query.sousType = [TIERS_SOUS_TYPE_COLLECTIVITE];
    if (data.query.tiers && data.query.tiers !== undefined) {
      data.query.tiersId = data.query.tiers.map(t => t.id);
      delete data.query.tiers;
    }
    transformer(data);
    const result = await getAll(data);
    const collectivitesIds = [];
    result.data.result.items.forEach((collectivite) => {
      collectivite.selected = false;
      collectivite.nombreMaterielPresentsAnnee = 0;
      collectivite.nombreMaterielDemonteAnneePrec = 0;
      collectivite.nombreMaterielMonteAnneePrec = 0;
      collectivitesIds.push(collectivite.id);
    });
    if (collectivitesIds.length > 0 && anneeDeclaration !== undefined) {
      const params = {
        collectivitesIds: collectivitesIds,
        annee: anneeDeclaration,
      };
      const response = (await getCountDeclarableAsync(params)).data.result;

      const paramsCommandesTlpe = {
        query: {
          tiersId: collectivitesIds,
          anneesDeclaration: [anneeDeclaration],
          societeId: data.query.societeId,
          typesDeclaration: [
            DECLARATION,
            MATERIEL_EN_PLACE,
            MONTAGES_ANNEE_PREC,
            DEMONTAGES_ANNEE_PREC,
          ],
        },
        limit: NO_PAGINATION,
      };

      const commandesTlpe = (await getAllCommandeTlpe(paramsCommandesTlpe)).data.result.items;

      result.data.result.items.forEach((collectivite) => {
        const infoDec = response[collectivite.id];
        const commandesCollectivite = commandesTlpe.filter((cmd) => {
          return cmd.intervenants.map((int) => int.tiersId).includes(collectivite.id);
        });
        collectivite.nombreMaterielPresentsAnnee = infoDec
          ? infoDec.nombreMaterielPresentsAnnee : null;
        collectivite.nombreMaterielDemonteAnneePrec = infoDec
          ? infoDec.nombreMaterielDemonteAnneePrec : null;
        collectivite.nombreMaterielMonteAnneePrec = infoDec
          ? infoDec.nombreMaterielMonteAnneePrec : null;
        if (commandesCollectivite) {
          collectivite.commandes = commandesCollectivite.map((cmd) => {
            return {
              id: cmd.id,
              code: cmd.code,
            };
          });
        } else collectivite.commandes = null;
      });
    }
    commit(SET_COLLECTIVITE_LAST_PAYLOAD, data);
    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
